<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 font-weight-light mb-8">
      <div class="signature">
        Daniel & Isabell
      </div>
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      September 17th 2022 * Göteborg<span v-if="!isOver"> * {{ daysLeft }} days to go!</span>
    </v-responsive>
    <v-btn
      href="http://isabellochdaniel.se/rsvp/"
      color="primary"
      elevation="2"
      rounded
      target="_blank"
    >
      RSVP
    </v-btn>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
    data () {
      return {
        today: new Date(),
        weddingDate: new Date(2022, 8, 17),
      }
    },

    computed: {
      daysLeft () {
        return Math.ceil((this.weddingDate.getTime() - this.today.getTime()) / (1000 * 60 * 60 * 24))
      },
      isOver () {
        return this.today.getTime() > this.weddingDate.getTime()
      },
    },

    created () {
      this.today = new Date()
    },

  }
</script>
